import React, { useEffect, useState } from 'react';

export const WebSocketTest = () => {
  const [status, setStatus] = useState('Disconnected');
  const [messages, setMessages] = useState<string[]>([]);

  useEffect(() => {
    // Create a test WebSocket connection
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const host = window.location.host;
    const wsUrl = `${protocol}//${host}/ws/test`;
    
    console.log(`[WEBSOCKET-TEST] Attempting to connect to: ${wsUrl}`);
    const ws = new WebSocket(wsUrl);
    
    ws.onopen = () => {
      setStatus('Connected');
      setMessages(prev => [...prev, 'Connection established']);
      console.log('[WEBSOCKET-TEST] Connection established');
      
      // Send a test message
      ws.send(JSON.stringify({ type: 'ping' }));
    };
    
    ws.onmessage = (event) => {
      console.log('[WEBSOCKET-TEST] Message received:', event.data);
      setMessages(prev => [...prev, `Received: ${event.data}`]);
    };
    
    ws.onerror = (error) => {
      console.error('[WEBSOCKET-TEST] Error:', error);
      setStatus('Error');
      setMessages(prev => [...prev, `Error occurred`]);
    };
    
    ws.onclose = (event) => {
      console.log('[WEBSOCKET-TEST] Connection closed, code:', event.code);
      setStatus('Closed');
      setMessages(prev => [...prev, `Connection closed (code: ${event.code})`]);
    };
    
    return () => {
      console.log('[WEBSOCKET-TEST] Cleaning up connection');
      ws.close();
    };
  }, []);

  return (
    <div className="p-4 border rounded">
      <h3>WebSocket Test</h3>
      <div>Status: <span className={
        status === 'Connected' ? 'text-green-500' : 
        status === 'Error' ? 'text-red-500' : 
        'text-yellow-500'
      }>{status}</span></div>
      <div className="mt-2">
        <h4>Messages:</h4>
        {messages.length === 0 ? (
          <p className="text-gray-500">No messages yet</p>
        ) : (
          <ul className="list-disc pl-5">
            {messages.map((msg, i) => (
              <li key={i}>{msg}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
